import { defineComponent as _defineComponent } from 'vue'
import { ComputedRef, computed } from "vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { useServiceStore } from "@/stores/serviceStore";
import { ISignupInfo } from "@/domain/entities/serviceInfo/serviceInfo.types";
import TypeOfSignUpRow from "@/components/signup/TypeOfSignUpRow.vue";
import router from "@/router";
import Page from "@/components/shared/Page.vue";
import { RouterName, SESSION_KEY_RANK_CODE } from "@/types";
import useSetSessionStorageItem from "@/use/useSetSessionStorageItem";


const __default__ = {
  name: "TypesOfSignUp",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const serviceStore = useServiceStore();
const signupInfos: ComputedRef<ISignupInfo[]> = computed(
  () => serviceStore.signupInfos ?? []
);

const goToLogin = () => {
  router.currentRoute.value.meta.willGoBack = true;
  router.back();
};

const goToTermsOfUse = (useRankCode?: string) => {
  if (useRankCode) {
    useSetSessionStorageItem(SESSION_KEY_RANK_CODE, useRankCode);
  }
  router.push({ name: RouterName.TermsOfUse });
};

const __returned__ = { serviceStore, signupInfos, goToLogin, goToTermsOfUse, NavigationBar, TypeOfSignUpRow, Page }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})